import { logUsage } from 'owa-analytics';
import RoamingTimezone, {
    ROAMING_TIMEZONE_IS_VISIBLE_PROP,
    ROAMING_TIMEZONE_TIMEZONE_ID_PROP,
    ROAMING_TIMEZONE_TIMEZONE_LABEL_PROP,
    ROAMING_TIMEZONE_PROP_LENGTH_MAX,
    ROAMING_TIMEZONE_PROP_LENGTH_MIN,
    MAX_COUNT_ROAMING_TIMEZONES,
} from '../store/schema/RoamingTimezone';

/**
 * Validates the roaming timezones setting value
 * @param settingValue
 * @returns the setting value converted to RoamingTimezone[]
 */
export default function validateRoamingTimezonesValue(
    settingValue: string
): RoamingTimezone[] | null {
    try {
        const parsedSettingValue = JSON.parse(settingValue);

        if (!Array.isArray(parsedSettingValue)) {
            logUsage('RoamingTimezonesError', { error: 'Unexpected setting type' });
            return null;
        }

        const timezones: RoamingTimezone[] = [];

        parsedSettingValue.forEach(item => {
            if (isRoamingTimezone(item)) {
                timezones.push(item);
            } else {
                logUsage('RoamingTimezonesError', { error: 'Unexpected timezone item type' });
            }
        });

        return timezones.length > 0 ? timezones.slice(0, MAX_COUNT_ROAMING_TIMEZONES) : null;
    } catch (e) {
        logUsage('RoamingTimezonesError', { error: 'Json parse error' });
        return null;
    }
}

function isRoamingTimezone(object: any): object is RoamingTimezone {
    const objectPropLength = Object.keys(object).length;

    // Time zone object might not have a label
    const isRoamingTimezoneBaseObject =
        objectPropLength >= ROAMING_TIMEZONE_PROP_LENGTH_MIN &&
        objectPropLength <= ROAMING_TIMEZONE_PROP_LENGTH_MAX &&
        ROAMING_TIMEZONE_IS_VISIBLE_PROP in object &&
        typeof object[ROAMING_TIMEZONE_IS_VISIBLE_PROP] == 'boolean' &&
        ROAMING_TIMEZONE_TIMEZONE_ID_PROP in object &&
        typeof object[ROAMING_TIMEZONE_TIMEZONE_ID_PROP] == 'string';

    // Time zone object has a label
    if (objectPropLength == ROAMING_TIMEZONE_PROP_LENGTH_MAX) {
        return (
            isRoamingTimezoneBaseObject &&
            ROAMING_TIMEZONE_TIMEZONE_LABEL_PROP in object &&
            typeof object[ROAMING_TIMEZONE_TIMEZONE_LABEL_PROP] == 'string'
        );
    }

    return isRoamingTimezoneBaseObject;
}
